import React, { useState } from 'react'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import MuiAlert from "@material-ui/lab/Alert";
import LoginModal from "../../LoginModal/Index";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Snackbar from "@material-ui/core/Snackbar";
import Rating from '@material-ui/lab/Rating';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ReplyIcon from '@material-ui/icons/Reply';
import TextField from "@material-ui/core/TextField";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CloseIcon from '@material-ui/icons/Close';
import { Formik } from "formik";
import * as yup from "yup";
import { withStyles } from "@material-ui/core/styles"
import Backdrop from "@material-ui/core/Backdrop/Backdrop"
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    closeIcon: {
        cursor: 'pointer'
    },
    grayBox: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingLeft: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(4)
        },
    },
    red: {
        color: '#950000',

    },
    avatarIcon: {
        width: '1.5em !important',
        height: '1.5em !important',
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    noBgAndShdaw: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 'none',
    },
    imgContiner: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 'none',
        textAlign: 'center'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'right',
        color: theme.palette.text.secondary,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: '150px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        border: '1px #3d3d3d solid',
        height: '40px',
        marginTop: '0px',
        paddingRight: '10px !important',
    },
    root: {
        display: 'flex',
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    buyButton: {
        display: 'block',
        marginTop: '40px',
        width: '100%',
        backgroundColor: '#28a504',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: "#417557",
        },
    },
    productTitle: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            marginBottom: '30px'
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.8rem',
            fontWeight: '700',
            marginTop: '15px',
            marginBottom: '15px',
            marginRight: '14px',
        }
    },
    price: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            color: '#950000'
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.8rem',
            fontWeight: '700',
            color: '#950000',
            marginRight: '14px',
            marginBottom: '15px',
        }
    },
    selectWeight: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1rem',
            marginTop: '30px',
            marginBottom: '5px'
        },
        [theme.breakpoints.down("md")]: {
            fontSize: '0.900rem',
            marginBottom: '10px',
        }
    },
    ratingBox: {
        [theme.breakpoints.up("sm")]: {
            textAlign: 'left'
        },
        [theme.breakpoints.down("md")]: {
            textAlign: 'right',
            paddingRight: '12px',
        }
    },
    propTitle: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            marginBottom: '15px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '1rem',
            fontWeight: '700',
            marginBottom: '15px',
            marginTop: '10px',
        }
    },
    propContent: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '0.950rem',
            marginTop: '20px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.850rem',
            marginTop: '20px',
        }
    },
    boxRight: {
        [theme.breakpoints.up("sm")]: {
            borderLeft: '1px #ccc solid',
            paddingLeft: '30px',
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: '0px'
        }
    },
    properties: {
        [theme.breakpoints.up("sm")]: {
            margin: '0px 25px 0px 25px',
        },
        [theme.breakpoints.down("sm")]: {
            margin: '30px 0px 20px 0px',
        },
    },
    bookmarkbar: {
        textAlign: 'left',
        [theme.breakpoints.up("sm")]: {
            marginTop: '24px'
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: '0px'
        },
    },
    btnAddBookmark: {
        backgroundColor: "transparent",
        boxShadow: 'none !important',
        border: 'none',
        padding: '0px !important',
        '&:hover': {
            backgroundColor: "transparent",
        },
        '&:focus': {
            backgroundColor: "transparent",
        },
    },
    counterBox: {
        [theme.breakpoints.up("sm")]: {
            textAlign: 'left',
            marginTop: '24px',
        },
        [theme.breakpoints.down("sm")]: {
            textAlign: 'left',
            marginTop: '25px',
        },
    }
}));

const StyledPaper = withStyles({
    root: {
        backgroundColor: "transparent",
        position: "relative",
        boxShadow: "none",
        paddingTop: "0",
    },
})(Paper);

const LimitedBackdrop = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
        marginTop: "-10px",
    },
})(Backdrop);

const validationSchema = yup.object({
    Text: yup
        .string("لطفا پیام خود را وارد کنید.")
        .required("وارد کردن متن پیام الزامی می باشد.")
        .max(400, ' حداکثر طول متن  160 کاراکتر می باشد.'),
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CommentArea = ({ cLoading, cError, comments, totalPages, loggedIn, userInfo, userData, itemId, typeOfEntities, showStar, btnSendText }) => {

    const classes = useStyles();
    const [starValue, setStarValue] = React.useState(0)
    const [btnText, setBtnText] = useState(btnSendText)
    const [pageLoading, setPageLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const [commentText, setCommentText] = React.useState('')
    const [showReplyBox, setShowReplyBox] = React.useState(false)
    const [replayId, setReplayId] = useState(0)
    const [replayedTo, setReplayedTo] = useState('')
    const [targetCommentText, setTargetCommentText] = useState('')
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    const onClose = () => {
        setIsModalOpen(false);
    }

    const handleCloseReplay = () => {
        setShowReplyBox(false)
        setReplayId(0)
        setTargetCommentText('')
        setReplayedTo('')
    }

    const handleReplayBtn = (cid) => {
        const commentInfo = comments.find(dataObj => dataObj.id === cid)
        if (typeof commentInfo !== 'undefined') {
            setShowReplyBox(true)
            setReplayId(Number(cid))
            setTargetCommentText(commentInfo.text)
            setReplayedTo(commentInfo.user.fullName)
        }
    }

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const openModal = () => {
        setIsModalOpen(true);
    }

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const sendComment = async (datas) => {

        if (!cLoading) {

            setBtnText('در حال ارسال...')
            setPageLoading(true)

            try {
                let url = ''
                if (typeOfEntities === "products") {
                    url = `/api/products/comments/add`
                }
                else if (typeOfEntities === "article") {
                    url = `/api/articles/comments/add`
                }
                const { data } = await axios.post(url, datas, {
                    headers: {
                        Authorization: `Bearer ` + localStorage.getItem("token"),
                        "content-type": "multipart/form-data",
                    },
                });
                if (data.status === "ok") {
                    toggleOpenAlert("success", "نظر شما با موفقیت ثبت شد.");
                    setCommentText('');
                    setShowReplyBox(false)
                    setReplayId(0)
                    setTargetCommentText('')
                    setReplayedTo('')
                } else {
                    toggleOpenAlert("error", "عملیات با خطا مواجه شده است.");
                }
            } catch (error) {
                console.error(error.message);
                toggleOpenAlert("error", "خطای ارتباط با سرور");
            }
            setPageLoading(false);
            setBtnText(btnSendText)

        }

    };

    return (
        <>
            <Grid item md={12} xs={12} style={{ marginTop: '25px' }}>
                <Paper elevation={0} className={classes.paperNoBg}>
                    <Box boxShadow={1} p={4} pt={2} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.grayBox}>
                        <h2 className="smallTitle">نظرات کاربران</h2>
                        <hr />
                        {(cLoading) ? (
                            <>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Box elevation={0} textAlign="center">
                                            <div className={classes.progressContiner}>
                                                <CircularProgress />
                                            </div>
                                            <p>در حال بارگزاری...</p>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>
                        ) : (
                            (comments.length > 0) ? (
                                comments.map((comment, i) => (
                                    <>
                                        <Box elevation={0} bgcolor="#fff" borderRadius={20} boxShadow={0} mt={4} p={2} py={2} m={1}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="right">
                                                        <table>
                                                            <tr key={1}>
                                                                <td key={1}>
                                                                    {(comment.user.imgURL !== "" && comment.user.imgURL !== null) ? (
                                                                        <img
                                                                            src={comment.user.imgURL}
                                                                            width="36px"
                                                                            height="36px"
                                                                            style={{ borderRadius: "50%" }}
                                                                        />
                                                                    ) : (
                                                                        <AccountCircleIcon className={classes.avatarIcon} />
                                                                    )}
                                                                </td>
                                                                <td key={2} style={{ verticalAlign: 'top', paddingTop: '8px' }}>
                                                                    {comment.user.fullName}
                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </Paper>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="right">
                                                        {comment.date}
                                                    </Paper>
                                                </Grid>
                                                <Grid item md={6}>
                                                    <Paper elevation={0} className={classes.paperNoBg} style={{ textAlign: 'left' }}>
                                                        <Rating value={comment.starRating} float="right" />
                                                    </Paper>
                                                </Grid>
                                                <Grid item md={12}>
                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                        <hr style={{ color: '#C5C5C5' }} />
                                                    </Paper>
                                                </Grid>
                                                <Grid item md={12}>
                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                        <Box mt={2}>
                                                            {comment.text}
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                                <Grid item md={12} style={{ marginTop: '5px' }}>
                                                    <Paper elevation={0} className={classes.paperNoBg} style={{ textAlign: 'left' }}>
                                                        {(loggedIn) ? (
                                                            <AnchorLink href='#commentSend' onClick={() => { handleReplayBtn(comment.id) }}><ReplyIcon className={classes.red} /></AnchorLink>
                                                        ) : (
                                                            <span style={{ cursor: 'pointer' }} onClick={openModal}><ReplyIcon className={classes.red} /></span>
                                                        )}
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {(comment.commentReplays.length > 0) && (
                                            comment.commentReplays.map((replay, i) => (
                                                <Grid container>
                                                    <Grid item xs={1}></Grid>
                                                    <Grid item xs={11}>
                                                        <Box elevation={0} bgcolor="#fff" borderRadius={20} boxShadow={0} mt={4} p={2} py={2} m={1}>
                                                            <Grid container>
                                                                <Grid item md={3}>
                                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="right">
                                                                        <table>
                                                                            <tr key={1}>
                                                                                <td key={1}>
                                                                                    {(replay.user.imgURL !== "" && replay.user.imgURL !== null) ? (
                                                                                        <img
                                                                                            src={replay.user.imgURL}
                                                                                            width="36px"
                                                                                            height="36px"
                                                                                            style={{ borderRadius: "50%" }}
                                                                                        />
                                                                                    ) : (
                                                                                        <AccountCircleIcon className={classes.avatarIcon} />
                                                                                    )}
                                                                                </td>
                                                                                <td key={2} style={{ verticalAlign: 'top', paddingTop: '8px' }}>
                                                                                    {replay.user.fullName}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item md={3}>
                                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="right">
                                                                        {replay.date}
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item md={6}>
                                                                    <Paper elevation={0} className={classes.paperNoBg} style={{ textAlign: 'left' }}>
                                                                        <Rating value={comment.starRating} float="right" />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item md={12}>
                                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                                        <hr style={{ color: '#C5C5C5' }} />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item md={12}>
                                                                    <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                                        <Box mt={2}>
                                                                            {replay.text}
                                                                        </Box>
                                                                    </Paper>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            ))
                                        )}
                                    </>
                                ))
                            ) : (
                                <Alert severity="info" style={{ marginTop: ' 15px', marginBottom: ' 15px' }}>نظری ثبت نشده است.</Alert>
                            )
                        )}
                        <h2 className="smallTitle" style={{ marginTop: '15px' }}>ثبت نظر</h2>
                        {(loggedIn) ? (
                            <>
                                <hr style={{ color: '#ccc' }} />
                                <Grid item md={12} xs={12}>
                                    <Paper elevation={0} className={classes.paperNoBg}>
                                        <Formik
                                            style={{ width: "100%" }}
                                            enableReinitialize
                                            initialValues={{
                                                Text: commentText,
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={(values) => {
                                                let formData = new FormData();
                                                if (typeOfEntities === "products") {
                                                    formData.append("ProductId", itemId);
                                                }
                                                else if (typeOfEntities === "article") {
                                                    formData.append("ArticleId", itemId);
                                                }
                                                if (Number(replayId) !== 0) {
                                                    formData.append("ReplayId", replayId);
                                                }
                                                formData.append("StarRating", starValue);
                                                formData.append("Text", values["Text"]);
                                                setCommentText(values["Text"])
                                                sendComment(formData)
                                            }}
                                            render={({
                                                handleSubmit,
                                                handleChange,
                                                handleBlur,
                                                values,
                                                touched,
                                                errors,
                                                setFieldValue,
                                                isSubmitting,
                                            }) => (
                                                <form onSubmit={handleSubmit}>
                                                    <Box evelotion={0} mt={1}>
                                                        <Grid container spacing={2} id="commentSend">
                                                            <Grid item md={12} xs={12}>
                                                                <Collapse in={showReplyBox}>
                                                                    <Box
                                                                        elevation={0}
                                                                        bgcolor="#fff"
                                                                        borderRadius={20}
                                                                        boxShadow={0}
                                                                        mt={4}
                                                                        p={2}
                                                                        py={2}
                                                                        ml={{ md: 3, lg: 3 }}>
                                                                        <Grid container>
                                                                            <Grid item md={12}>
                                                                                <Paper elevation={0} className={classes.paperNoBg} textAlign="right">
                                                                                    <table style={{ height: '40px' }}>
                                                                                        <tr>
                                                                                            <td style={{ verticalAlign: 'middle' }}>
                                                                                                <CloseIcon className={classes.closeIcon} onClick={handleCloseReplay} />
                                                                                            </td>
                                                                                            <td style={{ verticalAlign: 'top', paddingTop: '3px' }}>در پاسخ به نظر <strong>{replayedTo}</strong></td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </Paper>
                                                                            </Grid>
                                                                            <Grid item md={12}>
                                                                                <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                                                    <hr style={{ color: '#C5C5C5' }} />
                                                                                </Paper>
                                                                            </Grid>
                                                                            <Grid item md={12}>
                                                                                <Paper elevation={0} className={classes.paperNoBg} textAlign="left">
                                                                                    <p>{targetCommentText}</p>
                                                                                </Paper>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Box>
                                                                </Collapse>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Box mt={1}>
                                                                    <table>
                                                                        <tr key={1}>
                                                                            <td key={1}>
                                                                                {(userInfo.userImg !== null && userInfo.userImg !== '') ? (
                                                                                    <img
                                                                                        src={userInfo.userImg}
                                                                                        width="36px"
                                                                                        height="36px"
                                                                                        style={{ borderRadius: "50%" }}
                                                                                    />
                                                                                ) : (
                                                                                    <AccountCircleIcon className={classes.avatarIcon} />
                                                                                )}
                                                                            </td>
                                                                            <td key={2} style={{ verticalAlign: 'top', paddingTop: '8px' }}>
                                                                                <strong>{userInfo.fullName}</strong>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </Box>
                                                            </Grid>
                                                            <Grid item md={(showStar) ? 10 : 12} xs={12}>
                                                                <Box>
                                                                    <TextField
                                                                        multiline
                                                                        rows={4}
                                                                        fullWidth
                                                                        name="Text"
                                                                        variant="outlined"
                                                                        placeholder="متن نظر خود را اینجا وارد کنید."
                                                                        value={values.Text}
                                                                        style={{ borderRadius: '20px' }}
                                                                        onChange={handleChange}
                                                                        error={touched.Text && Boolean(errors.Text)}
                                                                        helperText={touched.Text && errors.Text}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                            {(showStar) && (
                                                                <Grid item md={2} xs={12}>
                                                                    <Box
                                                                        elevation={0}
                                                                        bgcolor="#fff"
                                                                        borderRadius={20}
                                                                        boxShadow={0}
                                                                        textAlign="center"
                                                                        p={2}
                                                                        pb={3}>
                                                                        <p>امتیاز خود را ثبت کنید</p>
                                                                        <Rating
                                                                            name="simple-controlled"
                                                                            value={starValue}
                                                                            mt={3}
                                                                            onChange={(event, newValue) => {
                                                                                setStarValue(newValue);
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                        <Box textAlign="center" p={4}>
                                                            <Button
                                                                variant="contained"
                                                                disabled={pageLoading}
                                                                style={{ backgroundColor: "#417557", color: '#fff', width: '200px', fontWeight: '700' }}
                                                                type="submit"
                                                                className={classes.green}>{btnText}</Button>
                                                        </Box>
                                                    </Box>
                                                </form>
                                            )}
                                        />
                                    </Paper>
                                </Grid>
                            </>
                        ) : (
                            <a onClick={openModal} style={{ cursor: 'pointer' }}>
                                <Alert style={{ marginBottom: '20px' }}>
                                    ثبت نام/ ورود جهت درج نظر الزامی است
                                </Alert>
                            </a>
                        )}
                    </Box>
                </Paper>
            </Grid>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <LoginModal open={isModalOpen} onClose={onClose} redirect={true} />
        </>
    )
}

export default CommentArea
